import Field from './Field';
import Person from './Person';
var Lead = /** @class */ (function () {
    function Lead(rawLead) {
        this.id = '';
        this.fields = [];
        this.person = new Person();
        if (!rawLead)
            return;
        var id = rawLead.id, fields = rawLead.fields, person = rawLead.person;
        this.id = id;
        this.fields = fields
            .slice()
            .map(function (field) { return new Field(field); })
            .sort(function (a, b) {
            return a.key.toLocaleLowerCase() > b.key.toLocaleLowerCase() ? 1 : -1;
        });
        this.person = new Person(person);
    }
    return Lead;
}());
export default Lead;
//# sourceMappingURL=Lead.js.map